import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {SignUpValidateToken, SignUpValidateTokenParams} from 'domain/usecases';

export class RemoteSignUpValidateToken implements SignUpValidateToken {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<void>,
	) {}

	async get({signal, ...queryParams}: SignUpValidateTokenParams): Promise<void> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params: queryParams,
			signal,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
